import Header from "../../../../../components/header";
import {
  FestivalSkeletonGrayBox,
  FestivalSkeletonPurpleBox,
} from "../../style/skeleton";
import RabbitFestivalCompetitionEventsSkeleton from "./components/events/skeleton";
import RabbitFestivalCompetitionTab from "./components/tab";
import { FestivalCompetitionWrapper } from "./style";

const RabbitFestivalCompetitionSkeleton = () => {
  return (
    <FestivalCompetitionWrapper>
      <Header
        title="RABBIT FESTIVAL"
        show={true}
        img={`/image-web/news/share_white.svg`}
      />
      <FestivalSkeletonGrayBox width="100%" height="360px" radius="0" />
      <FestivalSkeletonPurpleBox width="100%" height="35px" radius="0" />
      <RabbitFestivalCompetitionTab />
      <RabbitFestivalCompetitionEventsSkeleton />
    </FestivalCompetitionWrapper>
  );
};

export default RabbitFestivalCompetitionSkeleton;
